<template lang="pug">
    .b2b-filter-button-delivery-notes-emit
        ods-tag(
            closable='',
            type='secondary',
            @close='closeTagFilter')
                span.b2b-filter-button__value {{ $t(filter.value) + ': '}}
                span.b2b-filter-button__query {{ getLabel }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Utils from '@/components/shared/Utils'

export default {
  name: 'b2b-filter-button-delivery-notes-emit',
  mixins: [Utils],
  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      filterListAfterRemove: []
    }
  },

  computed: {
    ...mapGetters([
      'queryDeliveryNotesEmit',
      'listSelectedFiltersDeliveryNotesEmit',
      'urlIn'
    ]),

    getLabel () {
      if (this.filter.col.includes('Date')) {
        return this.$d(this.filter.labelText[0]) + '-' + this.$d(this.filter.labelText[1])
      } else {
        return this.filter.labelText
      }
    }
  },

  methods: {
    ...mapActions([
      'getDeliveryNotes',
      'queryDeliveryNotesEmitState'
    ]),

    async closeTagFilter () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete')
      })
      this.filter.selected = false // eslint-disable-line
      this.filterListAfterRemove = this.listSelectedFiltersDeliveryNotesEmit.filter(
        item => item.prop !== this.filter.prop
      )

      switch (this.filter.prop) {
        case 'projectId':
          this.queryDeliveryNotesEmit.projectId = ''
          break
        case 'buyerId':
          this.queryDeliveryNotesEmit.buyerId = ''
          this.queryDeliveryNotesEmit.buyerGenericCentreId = ''
          this.queryDeliveryNotesEmit.buyerCentreId = ''
          this.queryDeliveryNotesEmit.deliveryCentreId = ''
          break
        case 'sellerId':
          this.queryDeliveryNotesEmit.sellerId = ''
          this.queryDeliveryNotesEmit.sellerCentreId = ''
          break
        case 'statusId':
          this.queryDeliveryNotesEmit.statusId = ''
          break
        case 'orderNumber':
          this.queryDeliveryNotesEmit.orderNumber = ''
          break
        case 'deliveryNumber':
          this.queryDeliveryNotesEmit.deliveryNumber = ''
          break
        case 'invoiceNumber':
          this.queryDeliveryNotesEmit.invoiceNumber = ''
          break
        case 'issueDates':
          this.queryDeliveryNotesEmit.issueDateTimeFrom = ''
          this.queryDeliveryNotesEmit.issueDateTimeTo = ''
          break
        case 'deliveryDates':
          this.queryDeliveryNotesEmit.deliveryDateFrom = ''
          this.queryDeliveryNotesEmit.deliveryDateTo = ''
          break
        case 'noErrorStatus':
          this.queryDeliveryNotesEmit.noErrorStatus = ''
          break
      }
      try {
        if (this.urlIn && this.urlIn !== 'b2b') {
          this.queryDeliveryNotesEmit.urlName = this.urlIn
        } else {
          this.queryDeliveryNotesEmit.urlName = null
        }
        await this.queryDeliveryNotesEmitState(this.queryDeliveryNotesEmit)
        dataQuery.query = this.queryDeliveryNotesEmit
        await this.getDeliveryNotes(dataQuery)

        this.$emit('closeTag', { filter: this.filter, listAfterRemove: this.filterListAfterRemove })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$i18n.messages.es.error.e401
          break
        case 403:
          errorSms = this.$i18n.messages.es.error.e403
          break
        case 404:
          errorSms = error.data.message
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$i18n.messages.es.error.e500
          break
        default:
          errorSms = this.$i18n.messages.es.error.default
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
